import http from './http'
import { handleHttpError } from './httpHelpers'

export function getGlobalProductsService(data) {
    let params = {
        "customFunc": {
            "name": "cf_ottieniProdotti",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/prodotto/customfunc/', params, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function getProductsVariantService(data) {
    let params = {
        "customFunc": {
            "name": "cf_ottieniVarianti",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/prodottovariante/customfunc/', params, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function getAllProductsAndVariantService(data) {
    let params = {
        "customFunc": {
            "name": "cf_ottieniVariantiGlobali",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/prodottovariante/customfunc/', params, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}
export function getProductCategories(data) {
    let params = {
        "customFunc": {
            "name": "cf_ottieniCategorieProdotto",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/prodottocategoria/customfunc/', params, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}